// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-message-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.system-message-separator--room-create {
  background: none;
  box-shadow: none;
  border-radius: 0;
  padding: 12px 0;
  margin-top: 12px;
  margin-bottom: 0;
}

.system-message-separator-label {
  background: #e0e0e0;
  border-radius: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.10);
  padding: 8px 20px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #222;
  max-width: 80vw;
  display: inline-block;
}

.system-message-separator--room-create .system-message-separator-label {
  background: none;
  box-shadow: none;
  border-radius: 0;
  padding: 0;
  color: rgb(51, 51, 51);
  font-size: 12px;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/SystemMessageSeparator.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".system-message-separator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n\n.system-message-separator--room-create {\n  background: none;\n  box-shadow: none;\n  border-radius: 0;\n  padding: 12px 0;\n  margin-top: 12px;\n  margin-bottom: 0;\n}\n\n.system-message-separator-label {\n  background: #e0e0e0;\n  border-radius: 16px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.10);\n  padding: 8px 20px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 500;\n  color: #222;\n  max-width: 80vw;\n  display: inline-block;\n}\n\n.system-message-separator--room-create .system-message-separator-label {\n  background: none;\n  box-shadow: none;\n  border-radius: 0;\n  padding: 0;\n  color: rgb(51, 51, 51);\n  font-size: 12px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
